import { formatInTimeZone as b } from "date-fns-tz";
import { useRef as p } from "react";
const G = (e) => new Proxy({}, {
  get(t, n) {
    if (!(typeof window > "u"))
      throw new Error(`You must implement the ${n} by wrapping the component inside <${e}.provider value={{${n}}} />`);
  }
});
function c(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function w(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function h(e, t) {
  const n = c(e);
  return isNaN(t) ? w(e, NaN) : (t && n.setDate(n.getDate() + t), n);
}
function T(e, t) {
  const n = +c(e);
  return w(e, n + t);
}
const Q = 6048e5, X = 864e5, D = 6e4, N = 36e5;
function U(e, t) {
  return T(e, t * D);
}
function $(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function I(e) {
  if (!$(e) && typeof e != "number")
    return !1;
  const t = c(e);
  return !isNaN(Number(t));
}
function x(e, t) {
  const n = c(e), r = c(t);
  return n.getTime() > r.getTime();
}
function S(e, t) {
  const n = c(e), r = c(t);
  return +n == +r;
}
function j(e, t) {
  const r = R(e);
  let i;
  if (r.date) {
    const s = M(r.date, 2);
    i = _(s.restDateString, s.year);
  }
  if (!i || isNaN(i.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  const o = i.getTime();
  let a = 0, u;
  if (r.time && (a = O(r.time), isNaN(a)))
    return /* @__PURE__ */ new Date(NaN);
  if (r.timezone) {
    if (u = W(r.timezone), isNaN(u))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    const s = new Date(o + a), f = /* @__PURE__ */ new Date(0);
    return f.setFullYear(
      s.getUTCFullYear(),
      s.getUTCMonth(),
      s.getUTCDate()
    ), f.setHours(
      s.getUTCHours(),
      s.getUTCMinutes(),
      s.getUTCSeconds(),
      s.getUTCMilliseconds()
    ), f;
  }
  return new Date(o + a + u);
}
const m = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, A = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, C = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, v = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function R(e) {
  const t = {}, n = e.split(m.dateTimeDelimiter);
  let r;
  if (n.length > 2)
    return t;
  if (/:/.test(n[0]) ? r = n[0] : (t.date = n[0], r = n[1], m.timeZoneDelimiter.test(t.date) && (t.date = e.split(m.timeZoneDelimiter)[0], r = e.substr(
    t.date.length,
    e.length
  ))), r) {
    const i = m.timezone.exec(r);
    i ? (t.time = r.replace(i[1], ""), t.timezone = i[1]) : t.time = r;
  }
  return t;
}
function M(e, t) {
  const n = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"
  ), r = e.match(n);
  if (!r) return { year: NaN, restDateString: "" };
  const i = r[1] ? parseInt(r[1]) : null, o = r[2] ? parseInt(r[2]) : null;
  return {
    year: o === null ? i : o * 100,
    restDateString: e.slice((r[1] || r[2]).length)
  };
}
function _(e, t) {
  if (t === null) return /* @__PURE__ */ new Date(NaN);
  const n = e.match(A);
  if (!n) return /* @__PURE__ */ new Date(NaN);
  const r = !!n[4], i = d(n[1]), o = d(n[2]) - 1, a = d(n[3]), u = d(n[4]), s = d(n[5]) - 1;
  if (r)
    return E(t, u, s) ? Y(t, u, s) : /* @__PURE__ */ new Date(NaN);
  {
    const f = /* @__PURE__ */ new Date(0);
    return !Z(t, o, a) || !k(t, i) ? /* @__PURE__ */ new Date(NaN) : (f.setUTCFullYear(t, o, Math.max(i, a)), f);
  }
}
function d(e) {
  return e ? parseInt(e) : 1;
}
function O(e) {
  const t = e.match(C);
  if (!t) return NaN;
  const n = g(t[1]), r = g(t[2]), i = g(t[3]);
  return F(n, r, i) ? n * N + r * D + i * 1e3 : NaN;
}
function g(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function W(e) {
  if (e === "Z") return 0;
  const t = e.match(v);
  if (!t) return 0;
  const n = t[1] === "+" ? -1 : 1, r = parseInt(t[2]), i = t[3] && parseInt(t[3]) || 0;
  return P(r, i) ? n * (r * N + i * D) : NaN;
}
function Y(e, t, n) {
  const r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  const i = r.getUTCDay() || 7, o = (t - 1) * 7 + n + 1 - i;
  return r.setUTCDate(r.getUTCDate() + o), r;
}
const z = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function y(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function Z(e, t, n) {
  return t >= 0 && t <= 11 && n >= 1 && n <= (z[t] || (y(e) ? 29 : 28));
}
function k(e, t) {
  return t >= 1 && t <= (y(e) ? 366 : 365);
}
function E(e, t, n) {
  return t >= 1 && t <= 53 && n >= 0 && n <= 6;
}
function F(e, t, n) {
  return e === 24 ? t === 0 && n === 0 : n >= 0 && n < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function P(e, t) {
  return t >= 0 && t <= 59;
}
const V = new RegExp("^(?:[a-z]+:)?//", "i");
function ee(e) {
  return V.test(e);
}
function L(e) {
  return typeof e == "string";
}
function H(e) {
  return typeof e == "number";
}
function te(e) {
  try {
    return new URL(e), !0;
  } catch {
    return !1;
  }
}
function l(e) {
  if (L(e)) {
    const t = j(e);
    return q(t) ? t : new Date(e);
  } else if (H(e))
    return new Date(e);
  return e;
}
function ne(e, t = "d MMM yyyy - h:mma", n = "Asia/Hong_Kong") {
  return b(l(e), n, t);
}
function re(e, t) {
  return U(l(e), t);
}
function ie(e, t) {
  return h(l(e), t);
}
function se(e, t) {
  const n = l(e), r = l(t);
  return x(n, r) || S(n, r);
}
function q(e) {
  return I(e);
}
const oe = () => {
  const e = p(() => {
  }), t = p(() => {
  }), n = p(null);
  return n.current || (n.current = new Promise((r, i) => {
    e.current = r, t.current = i;
  })), {
    promise: n,
    reject: t,
    resolve: e
  };
};
function ae() {
  return typeof navigator > "u" ? !1 : /fban|fbav/i.test(navigator.userAgent);
}
const ce = (e, t) => {
  try {
    localStorage.setItem(e, t);
  } catch {
  }
};
function ue(e) {
  try {
    return e ? JSON.parse(e) : {};
  } catch {
    return {};
  }
}
function fe(e) {
  return !(e == null || e === "" || e === "0" || e === 0 || e === !1 || typeof e == "object" && Object.keys(e).length === 0);
}
function de(...e) {
  const t = /* @__PURE__ */ new Set();
  return [...e].flat().filter((n) => t.has(n) ? !1 : t.add(n));
}
function le() {
  return typeof window > "u" ? null : window;
}
function me(e) {
  return e.replaceAll("@media", "").trim();
}
function pe(...e) {
  var t, n;
  return (t = (n = e.find((r) => {
    var i;
    return (i = r == null ? void 0 : r.length) !== null && i !== void 0 ? i : !1;
  })) === null || n === void 0 ? void 0 : n.trim()) !== null && t !== void 0 ? t : "";
}
function J() {
  return typeof navigator == "object" && "userAgent" in navigator ? navigator.userAgent : typeof process == "object" && process.version !== void 0 ? `Node.js/${process.version.slice(1)} (${process.platform}; ${process.arch})` : "<environment undetectable>";
}
function ge() {
  const e = new RegExp("(" + ["WebView", "(iPhone|iPod|iPad)(?!.*Safari)", String.raw`Android.*(;\s+wv|Version/\d.\d\s+Chrome/\d+(\.0){3})`, "Linux; U; Android"].join("|") + ")", "ig"), t = J();
  return e.test(t);
}
export {
  I as A,
  h as B,
  ue as a,
  ge as b,
  G as c,
  ne as d,
  re as e,
  pe as f,
  le as g,
  ie as h,
  se as i,
  q as j,
  oe as k,
  ee as l,
  L as m,
  fe as n,
  H as o,
  l as p,
  te as q,
  me as r,
  ce as s,
  ae as t,
  de as u,
  c as v,
  w,
  X as x,
  D as y,
  Q as z
};
//# sourceMappingURL=index-CnymUPx7.mjs.map
